import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 300px;
`;

export const TypeContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TypeOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  width: 95%;
  margin-top: 20px;
`;

export const TypeDataContainer = styled.div`
  text-align: left;
  max-width: 40vw;
`;

export const TypeDataTitle = styled.h4``;

export const TypeDataText = styled.p`
  margin-left: 5px;
`;